import React, { useEffect } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { setConfig } from '../services/http';
import Container from './Container';
import CotizadorCR from './cotizadorcr/CotizadorCR';
import MicroSitioAuto from './pages/MicroSitioAuto';
import MicroSitioAutoHN from '../HN/Auto/MicroSitioAutoHN';
import MicroSitioNotificaReclamo from './notificacionreclamo/root';
import Root from './Root';
import MicrositioAutoCR from './cotizadorcr/MicrositioAutoCR';
import CotizadorNI from './cotizadorni/CotizadorNI';
import MicrositioAutoCRRoot from './cotizadorcr/MicrositioAutoCRRoute';
import SOA from './../NI/SOA/SOA';
import MicrositioAutoNIRoot from './cotizadorni/MicrositioAutoNIRoute';
import VivirSeguro from '../NI/VivirSeguro/VivirSeguro';
import MicrositioIndendioCRRoot from '../CR/Incendio/MicrositioIndendioCRRoot';
import MicrositioAutoHNRoot from '../HN/Auto/MicrositioAutoHNRoute';
import CoopenaeAuto from '../CR/Coopenae/Auto/CoopenaeAuto';
import CVS_Digital from '../NI/CVS_Digital/CVS_Digital';
import AutomovilCR from '../CR/Auto/Auto';
import Incendio_Hogar from '../CR/Incendio_Hogar/Incendio_Hogar';
import AutoNI from '../NI/Automovil/Auto';
import VivirSeguroCorreduria from '../NI/VivirSeguroCorreduria/VivirSeguro';
import AutoHN from '../HN/Automovil/Auto';
import IH_AutoExpedible_Contenido from '../CR/IH_AutoExpedible_Contenido/IH_AutoExpedible_Contenido';
import Reclamos_Inspeccion from '../NI/Reclamos_Inspeccion/Reclamos_Inspeccion';
import AutoCR from '../CR/Auto/Auto';
import SomexConsulta from '../HN/SomexConsulta/SomexConsulta'
import Auto_Emision_CR from '../CR/Auto_Emision/Auto_Emision_CR';
import VidaCR from '../CR/Vida/Vida'

const App = () => {
    useEffect(async () => {
       // console.log('int app')
        //await setConfig();
    }, []);

    return (
        <div>
            <BrowserRouter basename={process.env.PUBLIC_URL}>
                <Switch>
                    <Route exact path="/micrositio/automovil" component={MicroSitioAuto} />
                    <Route exact path="/micrositio/cotizadorni" component={MicrositioAutoNIRoot} />
                    <Route exact path="/micrositio/automovilni" component={MicrositioAutoNIRoot} />
                    <Route exact path="/micrositio/automovilhn" component={MicrositioAutoHNRoot} />
                    <Route exact path="/micrositio/cotizadorhn" component={MicrositioAutoHNRoot} />
                    <Route exact path="/micrositio/automovilcr" component={MicrositioAutoCRRoot} />
                    <Route exact path="/micrositio/cotizadorcr" component={MicrositioAutoCRRoot} />
                    <Route exact path="/micrositio/cotizadorcr3" component={MicrositioAutoCRRoot} />
                    <Route exact path="/micrositio/audebitoautomaticocr" component={MicrositioAutoCRRoot} />
                    <Route exact path="/micrositio/incendiocr" component={MicrositioIndendioCRRoot} />
                    <Route exact path="/micrositio/notificatureclamo" component={MicroSitioNotificaReclamo} />
                    <Route exact path="/micrositio/soa" component={SOA} />
                    <Route exact path="/micrositio/vivirseguro" component={VivirSeguro} />
                    <Route exact path="/micrositio/vivirsegurocorreduria" component={VivirSeguroCorreduria} />
                    <Route exact path="/micrositio/coopenae_auto" component={CoopenaeAuto} />
                    <Route exact path="/micrositio/cvs" component={CVS_Digital} />
                    <Route exact path="/micrositio/automovilcr2" component={AutomovilCR} />
                    <Route exact path="/micrositio/ih_cr" component={Incendio_Hogar} />
                    <Route exact path="/micrositio/auto_ni" component={AutoNI} />
                    <Route exact path="/micrositio/auto_hn" component={AutoHN} />
                    <Route exact path="/micrositio/cr/ih/autoexpedible_contenido" component={IH_AutoExpedible_Contenido} />
                    <Route exact path="/micrositio/ni/reclamos_inspeccion/:id" component={Reclamos_Inspeccion} />
                    <Route exact path="/micrositio/cr/auto" component={AutoCR} />
                    <Route exact path="/micrositio/hn/somex/consulta" component={SomexConsulta} />
                    <Route exact path="/micrositio/cr/auto/emision/:id" component={Auto_Emision_CR} />
                    <Route exact path="/micrositio/cr/vida" component={VidaCR} />
                    <Route path="/" component={Root} />
                </Switch>
            </BrowserRouter>
        </div>
    );
}

export default App;